<template>
  <div class="app-navbar-actions" :class="{ 'app-navbar-actions--mobile': isMobile }">
    <!-- Ocultos hasta corregir Mis Negocios y la sincronización SRI. -->
    <WorkspaceCreate v-if="!isMobile" />
    <SRIDropdown v-if="false && userStore.billingEnabled" class="app-navbar-actions__item" />
    <ProfileDropdown :sheet="isMobile" class="app-navbar-actions__item app-navbar-actions__item--profile mr-1" />
  </div>
</template>

<script lang="ts" setup>
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'
import SRIDropdown from './dropdowns/SRIDropdown.vue'
import WorkspaceCreate from './WorkspaceCreate.vue'
import { useUserStore } from '../../../stores/user'

defineProps({
  isMobile: { type: Boolean, default: false },
})

import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const userStore = useUserStore()
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;

  &--mobile {
    width: auto;
    min-width: 0;
    justify-content: flex-end;

    .app-navbar-actions__item,
    .app-navbar-actions__item--profile {
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.app-navbar-actions {

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    padding: 0;
    margin-left: 0.25rem;
    margin-right: 0.25rem;

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
